/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown> }} Readiness_Poor_SleepInputs */

const en_us2_readiness_poor_sleep = /** @type {(inputs: Readiness_Poor_SleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Short night: ${i?.pct}% fewer sets today, one rep in reserve more`)
};

const pt_br2_readiness_poor_sleep = /** @type {(inputs: Readiness_Poor_SleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Noite curta: ${i?.pct}% menos séries hoje, uma repetição a mais na reserva`)
};

const es_419_readiness_poor_sleep = /** @type {(inputs: Readiness_Poor_SleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Noche corta: ${i?.pct}% menos series hoy, una repetición más en reserva`)
};

const pt_pt2_readiness_poor_sleep = /** @type {(inputs: Readiness_Poor_SleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Noite curta: menos ${i?.pct}% de séries hoje, mais uma repetição de reserva`)
};

const fr_fr2_readiness_poor_sleep = /** @type {(inputs: Readiness_Poor_SleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nuit courte : ${i?.pct} % de séries en moins aujourd'hui, une répétition de plus en réserve`)
};

const de_de2_readiness_poor_sleep = /** @type {(inputs: Readiness_Poor_SleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kurze Nacht: heute ${i?.pct}% weniger Sätze, eine Wdh. mehr im Tank`)
};

const it_it2_readiness_poor_sleep = /** @type {(inputs: Readiness_Poor_SleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Notte corta: ${i?.pct}% di serie in meno oggi, una ripetizione di riserva in più`)
};

/**
* | output |
* | --- |
* | "Short night: {pct}% fewer sets today, one rep in reserve more" |
*
* @param {Readiness_Poor_SleepInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const readiness_poor_sleep = /** @type {((inputs: Readiness_Poor_SleepInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Readiness_Poor_SleepInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_readiness_poor_sleep(inputs)
	if (locale === "es-419") return es_419_readiness_poor_sleep(inputs)
	if (locale === "pt-PT") return pt_pt2_readiness_poor_sleep(inputs)
	if (locale === "fr-FR") return fr_fr2_readiness_poor_sleep(inputs)
	if (locale === "de-DE") return de_de2_readiness_poor_sleep(inputs)
	if (locale === "it-IT") return it_it2_readiness_poor_sleep(inputs)
	return en_us2_readiness_poor_sleep(inputs)
});
export { readiness_poor_sleep as "readiness.poor_sleep" }